export default (tourCriteria) => {
    const params = {};
    const element = tourCriteria.get('warranted');
    if (element) {
        params.warranted = element;
    }

    return params;
};